module.exports = __webpack_public_path__ + "media/images/medico_blanco-ea220fbda2e83c4c1f792abbb16119d4.svg";